import { Component, OnDestroy, OnInit } from '@angular/core';
import { Footer } from '../../core/components/footer/footer';
import { RouterOutlet } from '@angular/router';
import { Header } from 'app/core/components/header/header';


@Component({
  selector: 'app-private-layout',
  imports: [Footer, RouterOutlet, Header],
  templateUrl: './private-layout.html',
  styleUrl: './private-layout.scss'
})
export class PrivateLayout implements OnInit, OnDestroy{

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
